import script from "./InvoicePrint.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicePrint.vue?vue&type=script&setup=true&lang=js"

import "./InvoicePrint.vue?vue&type=style&index=0&id=35909a06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35909a06"]])

export default __exports__